import React ,  { useState,useEffect }from 'react';

const Title = (props)=>{
return(<div className="headline-container"><h3>{props.Copy}</h3></div>)
}

export default Title;




// WEBPACK FOOTER //
// ./src/js/Application/Default/js/Sections/SectionTitle.js